import create from './create';

const accounts = create();
const { register } = accounts;

export default register;
